<template>
    <div class="animated fadeIn">
        <transactions-filter v-model="request" />        
        <b-card>
            <c-table
                @onPageIndexChanged="onPageIndexChanged"
                @onExportToExcelClick="exportToExcel"
                :table-data="result"
                :loading="loading"
                :fields="fields"
                :striped="true"
                :export-enabled="$auth.isPartner"
                :actionUri="actionUri"
            ></c-table>
        </b-card>
    </div>
</template>
<script>
import cTable from "../../components/base/Table.vue";
import transactionService from "../../services/Transactions/transactionService";
import TransactionsFilter from './TransactionsFilter.vue';
import reportPage from './reportPage';
export default {
  name: "report-receivabletransactions",
  inheritAttrs: false,
  mixins: [reportPage],
  components: {
    cTable,
    TransactionsFilter
  },
  data: function () {
    return {
      actionUri: 'reports/transaction'
    };
  },
  created() {
    this.bindTableColumns();
    this.fetchData(1);
  },
  methods: {
    bindTableColumns() {
      this.fields.splice(4, 0, { key: "parcelFormatted", label: "Parcela", sortable: false },);
      if(this.$auth.isPartner) {
        this.fields.push({ key: "nuPartnerFeeFormatted", label: "Taxa", sortable: false });
        this.fields.push({ key: "acquirerFeeAmount", label: "Valor Adquire.", sortable: false });
        this.fields.push({ key: "spreadAmount", label: "Spread", sortable: false });
        this.fields.push({ key: "salespersonAmount", label: "Valor Rep.", sortable: false });      
      }
      else if(this.$auth.isFinance) {
        this.fields.push({ key: "nuPartnerFeeFormatted", label: "Taxa", sortable: false });
        this.fields.push({ key: "acquirerFeeAmount", label: "Valor Adquire.", sortable: false });
        this.fields.push({ key: "salespersonAmount", label: "Valor Rep.", sortable: false });
      }
      this.fields.push({ key: 'transactionActions', label: ''});
    },    
    fetchData(page) {      
      const self = this;
      this.showLoading();
      transactionService
        .forecast(
          this.getRequestParams(),
          page
        )
        .then(
          (response) => {
            if(response.status == 204) {
              self.result = self.getEmptyResult()
            }
            else {
              self.result.data = response.data.data
              let transaction = {}
              for(let i = 0; i <= self.result.data.length - 1; i++) {
                transaction = self.result.data[i]
                transaction.transactionId = transaction.id
                transaction.parcelFormatted = `${transaction.installment}/${transaction.installmentCount}`
                transaction.paymentMethodFormatted = `${transaction.paymentMethodTypeName} (${transaction.installmentCount}x) <img width="30px" src="${transaction.paymentMethodImage}" alt="${transaction.paymentMethodName}">`
                transaction.nuPartnerFeeFormatted = `${transaction.fee.toLocaleString('pt-BR', { style: 'decimal' })}% | ${transaction.feeAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`                                                              
              }
              self.result.pageIndex = page
              self.result.rowCount = response.data.total
              self.result.pageSize = 10
            }            
            self.hideLoading();
          },
          () => {
            self.result.data = [];
            self.hideLoading();
          }
        );
    },
    exportToExcel(tableName) {
      const self = this;
      this.showLoading();
      transactionService.forecastExport(this.getRequestParams()).then(
        (response) => {
          window.open(response);
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );      
    },
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>